import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import StaffDashboardView from '@/views/StaffDashboardView.vue'
import StaffOnboardCustomerView from '@/views/StaffOnboardCustomerView.vue'
import StaffManageSettingsView from '@/views/StaffManageSettingsView.vue'
import ManageAppProgressView from '@/views/ManageAppProgressView.vue'
import StaffProducts from '@/views/StaffProducts.vue'
import StaffProductDetail from '@/views/StaffProductDetail.vue'
import AdminProducts from '@/views/AdminProducts.vue'
import StaffPaymentsView from '@/views/StaffPaymentsView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Privacy.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('../views/Cookies.vue'),
  },
  {
    path: '/features',
    name: 'features',
    component: () => import('../views/FeaturesView.vue'),
  },
  {
    path: '/why',
    name: 'why',
    component: () => import('../views/WhyView.vue'),
  },
  {
    path: '/documentation',
    name: 'documentation',
    component: () => import('../views/DocumentationView.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/HelpCenterView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/DemoView.vue'),
  },
  {
    path: '/security',
    name: 'security',
    component: () => import('../views/SecurityView.vue'),
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: () => import('../views/BlogPostView.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/staff-dashboard',
    name: 'StaffDashboard',
    component: StaffDashboardView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/dashboard',
    name: 'CustomerDashboard',
    component: () => import('../views/CustomerDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Customer' }
  },
  {
    path: '/customer-settings',
    name: 'CustomerSettings',
    component: () => import('../views/CustomerSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Customer' }
  },
  {
    path: '/staff-onboard-customer',
    name: 'StaffOnboardCustomer',
    component: StaffOnboardCustomerView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-leads',
    name: 'StaffLeads',
    component: () => import('../views/StaffLeads.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/templates',
    name: 'staff-templates',
    component: () => import('../views/StaffTemplates.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/blog',
    name: 'staff-blog-manage',
    component: () => import('../views/StaffBlogManageView.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('../views/BillingView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/staff/products',
    name: 'StaffProducts',
    component: StaffProducts,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/products/:id',
    name: 'StaffProductDetail',
    component: StaffProductDetail,
    props: true,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-payments',
    name: 'StaffPayments',
    component: StaffPaymentsView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-manage-settings',
    name: 'StaffManageSettings',
    component: StaffManageSettingsView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/customers/:id',
    name: 'CustomerDetail',
    component: () => import('../views/CustomerDetailView.vue'),
    props: true,
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/templates',
    name: 'admin-templates',
    component: () => import('../views/AdminTemplates.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/revenue-reports',
    name: 'admin-revenue-reports',
    component: () => import('../views/AdminRevenueReportsView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/manage-app-progress',
    name: 'ManageAppProgress',
    component: ManageAppProgressView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/products',
    name: 'AdminProducts',
    component: AdminProducts,
    meta: { requiresAuth: true, role: 'Admin' }
  },

  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import('../views/AdminSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router